import React from 'react'
import {Icon} from '@chakra-ui/react'

const FavouriteFilledIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M16.99 1C15.16 1 13.41 1.9 12.04 3.39C10.55 1.88 8.82 1 7 1C2.89 1 0 3.95 0 8.67C0 12.24 2.01 15.84 5.73 19.36C6.67 20.35 12 24.18 12 24.18C12 24.18 17.19 20.42 18.28 19.35C21.99 15.84 24 12.24 24 8.67C24 3.97 21.06 1 16.99 1Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default FavouriteFilledIcon
